var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441.27,
    height: 4.957,
    viewBox: "0 0 441.27 4.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-200 -136.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1221,138.61c4.98-.1-1.545-.247-7.145-.373l-5.074.4Z",
    transform: "translate(-581.502)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1193.547,138.5l-13.815.41,9.976-.2c11.078.207-1.47.433-5.653.509C1202.192,139.119,1190.649,138.732,1193.547,138.5Z",
    transform: "translate(-581.502)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1166.358,138.821c-8.862-.03-6.385.238-2.662.322C1164.281,139.029,1170.079,138.9,1166.358,138.821Z",
    transform: "translate(-581.502)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M616.346,137.623c2.484.056,5.411.1,5,.169C624.121,137.715,624.707,137.651,616.346,137.623Z",
    transform: "translate(-238.311)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M621.344,137.792c-.534.014-1.108.03-1.79.046.561-.007,1.032-.009,1.669-.02C621.389,137.808,621.292,137.8,621.344,137.792Z",
    transform: "translate(-238.958)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M427.274,141.038c3.778-.2,5.9-.073,9.47-.158l1.995.331c3.869-.109,1.709-.28,4.519-.452,3.531.21,10.97.016,12.644.031,1.161.153-1.447.212-2.012.3,4.535-.111,4.216-.427,9.851-.431l.094.09c13.464-.471,30.532-.348,45.507-.645a2.943,2.943,0,0,1-1.152-.153c15.809-.12,34.052-.138,46.551-.922-8.544.086-23.018-.436-31.728.149-3.223-.235-8.188.106-9.526-.227-12.423-.145-17.475.445-29.423.455-1.712-.059-.881-.222-1.375-.378l9.469-.158-5.772-.132c2.5-.148,8.583-.041,9.275-.338-8.27.356-21.5.078-28.716.5,3.394.075,7.631-.013,11.647.013,1.766.106,4.5.183,4.323.343-11.488.463-21.015.235-32.816.381a71.877,71.877,0,0,1-7.457-.146c1.941-.055.476-.184,2.069-.26-4.183.134-.42.57-6.469.507l.775-.548c-2.4.579-7.4-.1-11.706.237-1.549-.219,1.306-.346,4.617-.362-3.76-.1-4.1.223-7.1.215l2.844-.467a29.173,29.173,0,0,1-7.535-.237c-.215.114,1.468.47-2.538.443-1.72-.06-.84-.178-1.244-.244a17.654,17.654,0,0,1-4.309.338c-.484-.156,1.758-.235,1.931-.4-1.995.01-3.621.04-5.067-.089-3.529.13.228.225-1.93.395-5.419-.111-.54-.542-2.537-.873,4.081-.223,9.333-.293,11.519-.417l-7.832.128c.474-.184-5.3-.315-1.162-.493-7.8-.169-17.232.035-24.714.183,1.06.063,2.425.1,2.2.217-3.871.109-3.44-.12-4.234-.252-2.864.127-2.545.443-4.3.677-5.91-.266-6.742-.1-11.775-.489l.311.317c-3.567-.255-4.088.223-7.93.037a13.549,13.549,0,0,1,2.44-.222c-3.4.1-3.137-.267-6.457-.145l2.634-.352c-2.645.012-6.525.121-5.16-.18-4.621.362-12.727.219-18.5.427l.382-.274c-2.983.332-10.969-.017-13.558.381l-.439-.111-5.94.368c-2.69-.033-1.777-.445-1.994-.331-5.9.073-10.531.1-14.327-.046-.954.368-7.165.464-12.1.51-23.8-.228-49.353.119-71.493.541-3.312.015-7.876.423-12.014.6,5.068.089,5.547-.1,10.53-.1,3.744.1,5.124.475,8.346.709l-1.638-.31c5.059-.251,3.486.165,7.484-.149l-.165.5a35.524,35.524,0,0,1,6.393.083l1.308-.346a37.06,37.06,0,0,1,6.232.583l-.311-.316c1.2.2,12.251-.035,8.471.505a27.533,27.533,0,0,1,3.792-.2l.307.315a58.215,58.215,0,0,1,7.018.035,10.693,10.693,0,0,0-2.634.353c12.342.055,2.609-1.033,13.54-1.061l-.127.2,2.774-.217,2.908.259c3.94-.7,15.342.063,21.941-.308,2.6-.057,6.011.358,10.943.312l-.321-.316c3.98.321,18.794.524,22.507,1.255,3.74-.245-.393-.066-.311-.316,7.3-.329,7.807.167,11.634.353,4.5-.157-3.438-.12-1.021-.358,6.886.24,5.591-.389,14.1-.18.844.178-2.2.124-3.073.242,5.985-.323,17.138-.126,26.039-.19,10.182.223,25.22.311,37.123.6l.221-.115c4.946.3,10.309.02,16.093.151Z",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M987.309,138.051l-2.5-.268-14.4.184C976.25,138.184,979.268,138,987.309,138.051Z",
    transform: "translate(-445.379)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M984.212,138.873l7.537-.127-12.194.021Z",
    transform: "translate(-448.568)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M801.683,138.449l1.866.042,27.455-.23Z",
    transform: "translate(-352.187)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M617.357,137.35c3.142-.142,7.654-.082,10.921-.179l-12.78.136Z",
    transform: "translate(-239.223)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M493.536,136.254c-4.857.486-9.665-.005-3.215.437C497.977,136.61,491.339,136.417,493.536,136.254Z",
    transform: "translate(-164.405)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M464.752,136.963c4.408.015,6.855-.057,9.27-.13A78.9,78.9,0,0,0,464.752,136.963Z",
    transform: "translate(-151.903)",
    fill: "#e5bda0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineMenu);
export default __webpack_public_path__ + "static/media/line-menu.994cb81c11063b92124e3305680bd2bb.svg";
export { ForwardRef as ReactComponent };